import { render, staticRenderFns } from "./TagsKeyword.vue?vue&type=template&id=eee5e752&scoped=true"
import script from "./TagsKeyword.vue?vue&type=script&setup=true&lang=js"
export * from "./TagsKeyword.vue?vue&type=script&setup=true&lang=js"
import style0 from "./TagsKeyword.vue?vue&type=style&index=0&id=eee5e752&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eee5e752",
  null
  
)

export default component.exports